import React, { useRef } from "react"
import styles from "./InputComponent.module.scss"

let idCounter = 0

const InputComponent = (props) => {
  const {
    hasCustomInput,
    onChange,
    onBlur,
    placeholder,
    subheader,
    value,
    customStyle,
    onfocus,
    className,
    ariaLabel,
    ...rest
  } = props

  const idRef = useRef(null)
  if (idRef.current === null) {
    idRef.current = `input-${++idCounter}`
  }
  const inputId = idRef.current
  
  if (hasCustomInput)
    return (
      <div className={styles.container}>
        <label className={styles.subheader} htmlFor={inputId}>{subheader}</label>
        <div className={styles.childInput}>{props.children}</div>
      </div>
    )

  // Determine the accessible label - prefer subheader, fall back to ariaLabel or placeholder
  const accessibleLabel = subheader || ariaLabel || placeholder

  return (
    <div
      className={styles.container}
      style={customStyle && customStyle.container}
    >
      {subheader ? (
        <label
          htmlFor={inputId}
          className={styles.subheader}
          style={customStyle && customStyle.subheader}
        >
          {subheader}
        </label>
      ) : (
        <label htmlFor={inputId} className={styles.srOnly}>
          {accessibleLabel}
        </label>
      )}
      <input
        id={inputId}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        value={value ? value : ""}
        className={className ? `${styles.input} ${className}` : styles.input}
        style={customStyle && customStyle.input}
        onFocus={onfocus ? onfocus : undefined}
        {...rest}
      />
    </div>
  )
}

export default InputComponent
